import { rem, rgba } from '@vimeo/bokeh-utils';
import { Button } from './button.js';

let Menu = {
  baseStyle: {
    button: { ...Button.baseStyle },
    list: {
      maxH: "420px",
      zIndex: "dropdown",
      borderRadius: "menuList",
      position: "relative",
      boxShadow: `0 0 ${rem(1)} 0 rgba(0, 0, 0, 0.15), 0 ${rem(4)} ${rem(8)} 0 rgba(0, 0, 0, 0.15)`,
      background: "white",
      overflowY: "auto",
      // :after styling interferes with item hover styling, commenting out for now
      // _after: {
      //   content: "''",
      //   position: 'absolute',
      //   height: '100%',
      //   width: '100%',
      //   border: '.125rem solid',
      //   borderColor: 'transparent',
      // },
      _focus: {
        outline: "none"
        // _after: {
        //   borderColor: 'blue.500',
        //   borderRadius: 'menuList',
        //   top: 0,
        // },
      },
      _dark: {
        border: "1px solid",
        borderColor: rgba(255, 255, 255, 0.125),
        background: "grayscale.950"
      }
    },
    item: {
      backgroundColor: "surface",
      padding: "0.5rem 1rem",
      cursor: "pointer",
      fontSize: "text-sm",
      _disabled: {
        opacity: "0.5",
        pointerEvents: "none",
        cursor: "not-allowed"
      },
      _hover: {
        background: rgba(0, 0, 0, 0.075)
      },
      _focus: {
        background: rgba(0, 0, 0, 0.075)
      },
      _highlighted: {
        background: rgba(0, 0, 0, 0.075)
      },
      _dark: {
        _focus: {
          background: rgba(255, 255, 255, 0.125)
        },
        _hover: {
          background: rgba(255, 255, 255, 0.125)
        },
        _highlighted: {
          background: rgba(255, 255, 255, 0.125)
        }
      }
    },
    command: {
      opacity: "0.8",
      letterSpacing: "tighter"
    },
    groupTitle: {
      fontWeight: "bold",
      padding: "0.5rem 1rem",
      margin: 0,
      backgroundColor: "surface"
    },
    divider: {
      color: rgba(0, 0, 0, 0.25),
      _dark: {
        color: rgba(255, 255, 255, 0.25)
      }
    }
  }
};

export { Menu };
